import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // 14 minutes and 50 seconds = 890 seconds
  const [timeLeft, setTimeLeft] = useState(890);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 890); // Reset if hits 0 for demo purposes
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="flex items-center font-bold text-white text-lg sm:text-xl" data-id="element-199">
      <Clock className="w-5 h-5 mr-2 animate-pulse" data-id="element-200" />
      <span data-id="element-201">
        OFERTA EXPIRA EN:{' '}
        <span className="font-mono text-yellow-300" data-id="element-202">
          {formatTime(timeLeft)}
        </span>
      </span>
    </div>;
}